<template>
  <v-container>
    <v-row justify="center" align="center">
      <v-col>
        <v-card elevation="14" color="#e8e4e4" class="rounded-lg uploaderCard">
          <v-row justify="center" align="center">
            <v-card-title class="card-title">
              dataset
            </v-card-title>
          </v-row>
          <v-row>
            <v-card-text class="subtitle-1 about-description">
              <p>1. Crowdsourced tagged anime illustration dataset
                <v-btn x-small icon href="https://www.gwern.net/Danbooru2019#danbooru2017">
                  <v-icon>fas fa-link</v-icon>
                </v-btn>
              </p>
              <p>2. Kaggle dataset 42 GB of dataset with 300,000 fan art pieces from Danbooru
                <v-btn x-small icon
                       href="https://www.kaggle.com/mylesoneill/tagged-anime-illustrations">
                  <v-icon>fas fa-link</v-icon>
                </v-btn>
              </p>
            </v-card-text>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
    <v-row justify="center" align="center">
      <v-col>
        <v-card elevation="14" color="#e8e4e4" class="rounded-lg uploaderCard">
          <v-row justify="center" align="center">
            <v-card-title class="card-title">
              model
            </v-card-title>
          </v-row>
          <v-row>
            <v-card-text class="subtitle-1 about-description">
              <p>1. UNet model architecture utilised for enhancing anime images.
                <v-btn x-small icon href="https://arxiv.org/abs/1505.04597">
                  <v-icon>fas fa-link</v-icon>
                </v-btn>
              </p>
              <p>2. Understanding semantic segmentation tutorial
                <v-btn x-small icon
                       href="https://towardsdatascience.com/understanding-semantic-segmentation-with-unet-6be4f42d4b47">
                  <v-icon>fas fa-link</v-icon>
                </v-btn>
              </p>
            </v-card-text>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
    <v-row justify="center" align="center">
      <v-col>
        <v-card elevation="14" color="#e8e4e4" class="rounded-lg uploaderCard">
          <v-row justify="center" align="center">
            <v-card-title class="card-title">
              credits
            </v-card-title>
          </v-row>
          <v-row>
            <v-card-text class="subtitle-1 about-description">
              <p>1. Creators are Kshitij Karthick, Tofigh Naghibi
                <v-btn icon x-small
                       href="mailto:kshtj.karthick@gmail.com,tofigh@gmail.com?subject=ProJPG Feedback">
                  <v-icon>far fa-envelope</v-icon>
                </v-btn>
              </p>
              <p>2. Credits to FastAi, Pytorch, FastAPI, VueJs & Vuetify.</p>
            </v-card-text>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
name: "About"
}
</script>

<style scoped>
.card-title {
  font-size: 24px;
  text-align: center;
  font-variant: small-caps;
}
.about-description {
  margin-left: 24px;
  margin-right: 24px;
}
.uploaderCard {
  opacity: 0.85;
  padding: 16px 24px 32px;
}
</style>